// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"StackItemTitle_subtitleContainer__PWwpz","metadata":"StackItemTitle_metadata__3Z1KW"};